import {onDomReady} from "../lib/on_dom_ready";

onDomReady(() => {
  const emailInputs = document.querySelectorAll(".emailInput");

  emailInputs.forEach((input) => {
    input.addEventListener("input", () => {
      input.setAttribute("aria-invalid", String(!input.checkValidity()));
    });
  });
});
